import { toast } from 'sonner';
import i18next from 'i18next';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class PartyInstanceIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async getById(id, { silent = false } = {}) {
        try {
            const response = await this.service.getById(id);
            return { success: true, data: response.data || null };
        } catch (error) {
            if (!silent) toast.error(this._err(error));
            return { success: false, error: error.message };
        }
    }

    async fetchForEntity({ entityType, entityId, silent = false } = {}) {
        try {
            const response = await this.service.getAll({ entityType, entityId, pageSize: 1 });
            return { success: true, data: response.data?.[0] || null };
        } catch (error) {
            if (!silent) toast.error(this._err(error));
            return { success: false, error: error.message };
        }
    }

    async createForEntity(payload) {
        try {
            const response = await this.service.create(payload);
            toast.success(
                i18next.t('party:messages.instanceCreateSuccess', { defaultValue: 'Roles assigned' })
            );
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(this._err(error));
            return { success: false, error: error.message };
        }
    }

    async addAssignment(instanceId, assignment) {
        try {
            const response = await this.service.addAssignment(instanceId, assignment);
            toast.success(
                i18next.t('party:messages.assignmentAdded', { defaultValue: 'Member added' })
            );
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(this._err(error));
            return { success: false, error: error.message };
        }
    }

    async removeAssignment(instanceId, assignmentId) {
        try {
            const response = await this.service.removeAssignment(instanceId, assignmentId);
            toast.success(
                i18next.t('party:messages.assignmentRemoved', { defaultValue: 'Member removed' })
            );
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(this._err(error));
            return { success: false, error: error.message };
        }
    }

    _err(error) {
        return getIntegrationErrorMessage(error);
    }
}
